import React from 'react';
import SectionHeading from '../../Common/SectionHeading';
import { limitText } from "../../Common/Functions"
import Moment from 'react-moment';
import Link from 'next/link'
import BorderBtn from '../../Common/BorderBtn';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { useState, useEffect } from "react";
import { useMediaQuery } from 'react-responsive';

const RecentArticles = ({ filterData, year, eventSlugPrefix, slugPrefix, tail = "all" }) => {


  const showMoreLimit = 10;

  const [showMore, setShowMore] = React.useState(false);


  const AllTypes = [...new Set(filterData?.flatMap(article => article?.article_type?.map(type => type.value)))];
  const allCategories = [...new Set(filterData?.flatMap(article => article?.indications?.map(indications => indications.value)))];

  const [selectedTags, setSelectedTags] = React.useState([]);
  const [selectedCategories, setSelectedCategories] = React.useState([]);

  const handleTagSelection = (tag) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter(selectedTag => selectedTag !== tag));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
  };

  const handleCategorySelection = (category) => {
    if (selectedCategories.includes(category)) {
      setSelectedCategories(selectedCategories.filter(selectedCategory => selectedCategory !== category));
    } else {
      setSelectedCategories([...selectedCategories, category]);
    }
  };

  const filteredArticles = filterData?.filter(article => (
    (selectedTags.length === 0 || article.article_type?.some(types => selectedTags.includes(types.value))) &&
    (selectedCategories.length === 0 || article.indications?.some(indication => selectedCategories.includes(indication.value)))
  )).slice(0, 6);

  const visibleCategories = showMore ? allCategories : allCategories.slice(0, showMoreLimit);

  const visibleTarget = showMore ? AllTypes : AllTypes.slice(0, showMoreLimit);

  const isDesktop = useMediaQuery({ minWidth: 784 });
  const [expanded, setExpanded] = useState(false);

  const [expandedStates, setExpandedStates] = useState([false, false]);

  const togglePanel = (index) => {
    const newExpandedStates = [...expandedStates];
    newExpandedStates[index] = !newExpandedStates[index];
    setExpandedStates(newExpandedStates);
  };

  const toggleSection = () => {
    setExpanded(!expanded);
  };
  useEffect(() => {
    setExpanded(isDesktop);
  }, [isDesktop]);

  return (
    <div className='bg-[#f6f6f6]'>
      <div className='w-11/12 py-8 mx-auto xl:max-w-screen max-w-screen-2xl'>
        <SectionHeading title="Our Recent Articles" />
        <div className="grid grid-cols-12 gap-4">
          {/* Tags Filter */}
          <div className="col-span-12 lg:col-span-3">
            <div className="px-4 bg-white lg:hidden">
              <button
                onClick={toggleSection}
                className={`mobile-toggle mb-4 ${expanded ? ' expanded' : ''}`}
              >
                <span className="text-base font-semibold">REFINE BY</span>
                <FontAwesomeIcon icon={faFilter} className="text-sm p-2 text-[#1b5df3]" />
              </button>
            </div>
            <div className={`${expanded ? '' : 'hidden'} lg:block`}>
              <div className='p-4 bg-white'>
                <h3 className="text-md font-semibold pb-2 text-[#1b5df3]">Types / Technology</h3>
                <hr className='pb-2' />
                <div className="space-y-2">
                  {visibleTarget.map(tag => (
                    <div key={tag} className="flex items-center">
                      <input
                        type="checkbox"
                        id={tag}
                        checked={selectedTags.includes(tag)}
                        onChange={() => handleTagSelection(tag)}
                        className="mr-2"
                      />
                      <label htmlFor={tag}>{tag}</label>
                    </div>
                  ))}
                </div>
                {AllTypes.length > showMoreLimit && (
                  <div className="mt-2 text-center text-red-600">
                    <div onClick={() => setShowMore(!showMore)}>
                      {showMore ? 'Show Less' : 'Show More'}
                    </div>
                  </div>
                )}
              </div>

              <div className='p-4 mt-4 bg-white'>
                  <h3 className="text-md pb-2 font-semibold text-[#1b5df3]">Indications</h3>
                  <hr className='pb-2' />
                  <div className="space-y-2">
                    {visibleCategories.map((category, index) => (
                      <div key={category} className="flex items-center">
                        <input
                          type="checkbox"
                          id={category}
                          checked={selectedCategories.includes(category)}
                          onChange={() => handleCategorySelection(category)}
                          className="mr-2"
                        />
                        <label htmlFor={category}>{category}</label>
                      </div>
                    ))}
                  </div>
                  {allCategories.length > showMoreLimit && (
                    <div className="mt-2 text-center text-red-600">
                      <div onClick={() => setShowMore(!showMore)}>
                        {showMore ? 'Show Less' : 'Show More'}
                      </div>
                    </div>
                  )}
              </div>
            </div>
          </div>

          {/* Articles */}
          <div className="col-span-12 lg:col-span-9">
            <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
              {filteredArticles?.map((article, index) => (
                <div key={index} className="p-4 bg-white rounded shadow">
                  <h3 className='font-semibold text-md'>Title</h3>
                  {/* <div className="text-sm font-semibold text-gray-600">{article.tags.map((data, index) => {
                    return <p className='my-1' key={index}>{data}</p>
                  })}</div> */}
                  <p className="my-2 text-base line-clamp-2">{article.title}</p>
                  {/* <p className='text-xs'><i className="mr-1 fas fa-calendar-alt"></i><Moment format='dddd D MMMM yyyy'>{article.published_on}</Moment></p> */}
                  {(article.executive_summary || article.session) &&
                    <>
                      <h3 className='font-semibold text-md'>Summary</h3> 
                      <p className='my-2 text-base line-clamp-3'>{article.executive_summary ? article.executive_summary : article.session}</p>
                    </>
                  } 
                  {
                    (article.article_type) &&
                    <>
                      <h3 className='font-semibold text-md'>Article Type</h3> 
                      <div>
                        {article.article_type.map((data, index) => {
                          return <p className='my-1' key={index}>{data.value}</p>
                        })}
                      </div>
                    </>
                  }
                  <div className='mt-6 text-center'>
                    <BorderBtn 
                      customClass='w-full py-1 bg-[#1b5df3] border-[#1b5df3] text-white rounded'
                      buttonTitle="Go to Article"
                      buttonLink={process.env.APP_URL + `/${eventSlugPrefix}` + `/${slugPrefix}/` + article?.slug}
                    />
                  </div>
                  {/* /eular-conference/eular-2022 */}

                </div>
              ))}
            </div>
            <div className='my-4 text-center'><Link href={`/${eventSlugPrefix}/${tail}`}><button className='px-6 py-1 font-semibold text-white bg-red-600 rounded '>VIEW ALL</button></Link></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecentArticles;
